import * as React from 'react';

const styles = {
  footer: {
    padding: '0.5rem',
    fontSize: '1rem',
    backgroundColor: '#1f1f1f',
    textAlign: 'center',
    color: 'white',
  },
};

export default class Footer extends React.Component<void, void> {
  render() {
    return (
      <footer style={styles.footer} className="d-print-none fixed-bottom footer hidden-sm-down">
        &copy; 2017 - <a href="https://www.mtf.ch/de/?pl=schaffhausen" target="_blank">MTF</a>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Layout/Footer.js